import React, { useState, useEffect, useMemo } from "react";
import { getStyle } from "../../../styles/styles";
import { getBNVaults } from "../../../networking/NetworkingOrders";
import MultipleSelect from "../../shared/MultipleSelect";
import DatePicker from "../../shared/DatePicker";
import ClosingBalancesGrid from './ClosingBalancesGrid';
import { useClosingBalancesData } from './useClosingBalancesData';
import { GlobalSystemParametersNames } from "../../../../src/constants/GlobalSystemParametersNames";
import dayjs from "dayjs";
import TheCSVButton from '../../shared/TheCSVButton';

const style = getStyle();

export const ClosingBalancesScreen = () => {
  const [vaults, setVaults] = useState([]);
  const [selectedVaults, setSelectedVaults] = useState([]);
  const [closeDate, setCloseDate] = useState(() => {    
    let str_bnSystemDate=localStorage.getItem(GlobalSystemParametersNames.BNSystemDate);
    const today = dayjs(str_bnSystemDate, "YYYY-MM-DD").toDate();
    //const today = new Date();
    return today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
  });

  const vaultId = selectedVaults.length > 0 ? selectedVaults[0].VaultId : null;

  const params = useMemo(() => {
    return vaultId && closeDate ? { vaultId, closeDate } : null;
  }, [vaultId, closeDate]);

  const { columnsData, columnDetail } = useClosingBalancesData(params);

  useEffect(() => {
    const fetchVaults = async () => {
      const response = await getBNVaults();
      if (response && response.response && response.response.data) {
        const vaultData = response.response.data.map(vault => ({
          VaultId: vault.VaultID,
          Description: vault.Description
        }));
        setVaults(vaultData);
      } else if (response && response.data) {
        const vaultData = response.data.map(vault => ({
          VaultId: vault.VaultID,
          Description: vault.Description
        }));
        setVaults(vaultData);
      } else {
        setVaults([]);
      }
    };
    fetchVaults();
  }, []);  

  const onVaultsChange = (value) => {
    setSelectedVaults(value);
  };

  const onDateChange = (date) => {
    const dateStr = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    setCloseDate(dateStr);
  };

  return (
    <div>
      <h3 className="uk-heading-divider" style={style.titleStyle}>
        Closing Balances
      </h3>
      <div className="uk-form-stacked uk-grid">
        <div className="uk-width-4-12">
          <div className="uk-margin">
            <label className="uk-form-label" htmlFor="form-bank-name">Vault Selection</label>
            <div className="uk-form-controls">
              <MultipleSelect data={vaults} textField='Description' valueField='VaultId' onChange={onVaultsChange} />
            </div>
          </div>
        </div>
        <div className="uk-width-2-12">
          <div className="uk-margin">
            <label className="uk-form-label">Close Date</label>
            <DatePicker value={new Date(closeDate + 'T12:00:00')} onDayChange={onDateChange} />
          </div>
        </div>
        <div className="uk-width-6-12">
          <div className="uk-margin">
            {Array.isArray(columnsData) && columnsData.length > 0 ? (<TheCSVButton board={'ClosingBalances'} data={columnsData} useIcon={true}/>):(<div></div>)}
          </div>
        </div>
      </div>
      <br />
      <div>
        {Array.isArray(columnsData) && columnsData.length > 0 ? (
          <ClosingBalancesGrid columnsData={columnsData} columnDetail={columnDetail} />
        ) : (
          <div style={{ textAlign: 'center', marginTop: '40px', color: '#888' }}>No data to display</div>
        )}
      </div>
    </div>
  );
};
